import { useEffect, useState } from "react";
import {
  Input,
  Modal as ReactModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  ButtonGroup,
  Button,
} from "reactstrap";
import { ModalButton } from "../project/style";
import { CARPENTER_GROUPS, CARPENTER_ROOMS } from "../constants";
import { Notification } from "../common/style";

const CrudModal = ({
  isOpen,
  toggle,
  crudAction,
  id,
  name,
  roomId,
  groupId,
  text,
  isRoomAndGroup,
}) => {
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [inputValue, setInputValue] = useState("");

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const [roomValue, setRoomValue] = useState(CARPENTER_ROOMS[0]);
  const [groupValue, setGroupValue] = useState(CARPENTER_GROUPS[0]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setInputValue(name);
  }, [name]);

  const handleSaveClick = () => {
    if (name === inputValue && !roomValue) return toggle(false);

    crudAction(id, roomId || groupId, {
      name: inputValue,
      room_name: roomValue,
      group_name: groupValue,
      version,
    });

    toggle();
    setInputValue("");
  };

  const [version, setVersion] = useState(1);

  return (
    <>
      {notification.type && (
        <Notification
          color={notification.type === "error" ? "danger" : "success"}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notification.message}
        </Notification>
      )}
      <ReactModal isOpen={isOpen} toggle={toggle} backdrop="static">
        {isLoading && (
          <div className="position-absolute d-flex justify-content-center align-items-center w-100 h-100 z-3">
            <Spinner />
          </div>
        )}
        <ModalHeader>{text}</ModalHeader>
        <div className={`${isLoading ? "blurred" : ""}`}>
          <ModalBody>
            {isRoomAndGroup ? (
              <div className="mt-2 d-flex gap-10">
                <div>
                  <Input
                    id="roomSelect"
                    placeholder="Select Room"
                    name="selectRoom"
                    type="select"
                    value={roomValue}
                    onChange={(e) => {
                      setRoomValue(e.target.value);
                    }}
                  >
                    {CARPENTER_ROOMS.map((room, index) => {
                      return (
                        <option key={index} value={room}>
                          {room}
                        </option>
                      );
                    })}
                  </Input>
                </div>
                <div>
                  <Input
                    id="groupSelect"
                    placeholder="Select Group"
                    name="selectGroup"
                    type="select"
                    value={groupValue}
                    onChange={(e) => {
                      setGroupValue(e.target.value);
                    }}
                  >
                    {CARPENTER_GROUPS.map((group, index) => {
                      return (
                        <option key={index} value={group}>
                          {group}
                        </option>
                      );
                    })}
                  </Input>
                </div>
              </div>
            ) : (
              <>
                <Input
                  type="text"
                  className="mt-1"
                  value={inputValue || ""}
                  invalid={!inputValue}
                  onChange={(ev) => setInputValue(ev.target.value)}
                />
              </>
            )}
          </ModalBody>
          <ModalFooter className="pt-0 border-0">
            <ModalButton
              className="mt-0"
              color="primary"
              onClick={handleSaveClick}
              disabled={!inputValue && !roomValue}
            >
              Save
            </ModalButton>
            <ModalButton
              className="mt-0"
              color="secondary"
              onClick={() => {
                toggle();
              }}
            >
              Cancel
            </ModalButton>
          </ModalFooter>
        </div>
      </ReactModal>
    </>
  );
};

export default CrudModal;
